import React from 'react'
import { NoticeBox } from '@core/Components/NoticeBox'
import { DetailsWrapper } from '../TakeABreak.styles'

const TakeABreakError: React.FC = () => (
  <DetailsWrapper>
    <NoticeBox
      title='Sorry, an error occurred. Please try again later.'
      noticeBoxType='Error'
      hasBorder
    />
  </DetailsWrapper>
)

export default TakeABreakError
